var map = {
	"./1.jpeg": 763,
	"./Logo.png": 926,
	"./Logo_2.png": 785,
	"./about.jpeg": 561,
	"./aboutback.jpeg": 346,
	"./blog.jpeg": 624,
	"./calc.jpeg": 369,
	"./ceud.jpeg": 241,
	"./education.jpeg": 598,
	"./game.jpeg": 442,
	"./garage.jpeg": 622,
	"./person1.jpg": 495,
	"./resto.jpeg": 147,
	"./temp.jpeg": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;